import React, { FC, useEffect, useRef } from 'react'
import { createStyles, makeStyles, InputAdornment, Theme  } from '@zn-material-ui'
import Input from '@components/Input'
import classnames from 'classnames'
import SliderCaptcha, {
  CaptchaType,
  SuccessType,
} from '@components/SliderCaptcha'
import { transform } from '@utils/intl_lang'
interface IProps {
  captchaObj: CaptchaType | null
  count: number
  captcha: string
  getCaptcha: () => void
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  identityCodeError: boolean
  setCount: () => void
  onSuccess: (success: SuccessType) => void
  onCaptInit: (captObj: CaptchaType) => void
  phoneNum: string
  slideVisible?: boolean
}

const CaptchaInput: FC<IProps> = ({
  captcha,
  identityCodeError,
  onChange,
  count = -1,
  slideVisible,
  captchaObj,
  ...props
}) => {
  const classes = useStyles()
  const interval = useRef<NodeJS.Timeout>(null)

  const enableCaptcha = count === 0

  const getCaptcha = () => {
    if (!captchaObj || !slideVisible) {
      props.getCaptcha()
      return
    }
    if (!props.phoneNum.trim()) {
      // '请填写手机号！'
      global.$message(transform('Login_enter_mobile_number'))
      return
    }
    captchaObj.reset()
    const dom = document.getElementsByClassName('geetest_btn')[0] as HTMLElement
    dom?.click()
  }

  const onInit = (captchaObj: CaptchaType) => {
    props.onCaptInit(captchaObj)
  }

  const onSuccess = (success: SuccessType) => {
    props.onSuccess(success)
  }

  const endAdornment = (
    <InputAdornment position="end">
      <div
        className={classnames(
          classes.identityCodeLabel,
          !enableCaptcha ? classes.idCodeDisabled : ''
        )}
      >
        <span onClick={() => getCaptcha()} className={classnames(
          'captcha',
          !enableCaptcha ? 'disabled' : ''
        )}>
          {/* {enableCaptcha ? '获取短信验证码' : `${count}s后可重新获取`} */}
          {enableCaptcha
            ? '获取验证码'
            : transform('Login_get_code_again', { count })}
        </span>
      </div>
    </InputAdornment>
  )

  useEffect(() => {
    if (count > 0) {
      // @ts-ignore
      interval.current = setInterval(() => {
        props.setCount()
      }, 1000)
    } else {
      if (interval.current) {
        captchaObj?.reset()
        clearInterval(interval.current)
      }
    }
    return () => {
      if (interval.current) {
        clearInterval(interval.current)
      }
    }
  }, [count])

  return (
    <div style={{ position: 'relative' }}>
      <Input
        type="number"
        placeholder="请输入验证码"
        value={captcha}
        onChange={onChange}
        showLabel={identityCodeError}
        // '验证码错误' : '验证码'
        label={
          identityCodeError
            ? transform('Login_code_error')
            : transform('Login_code')
        }
        containerStyle={classes.captcha}
        endAdornment={endAdornment}
      />
      <div style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
        <SliderCaptcha
          loginType={1}
          onInit={onInit}
          onSuccess={onSuccess}
          type="201"
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    captcha: {
      width: '460px',
    },
    idCodeDisabled: {
      color: '#999',
    },
    identityCodeLabel: {
      position: 'relative',
      '& .captcha': {
        background: '#ffffff',
        textAlign: 'right',
        fontSize: 16,
        color: theme.palette.primary.main,
        width: 140,
        cursor: 'pointer',
        position: 'absolute',
        right: '0',
        top: '10%',
        transform: 'translateY(-50%)',
      },
      '& .disabled': {
        color: '#999',
      }
    },
  })
)
export default CaptchaInput
